import { h, Component } from 'preact'
import Renderer from '../canvas/renderer'
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import { multiAlign } from "../canvas/alignment";
import constants from '../constants'
import { moveBackward, moveForward, moveGroupBack, moveGroupForward, moveToBack, moveToFront } from "../canvas/layer";
import util from '../util';
import Interactable from '../canvas/interactable';
import Position from "./svg/Position";
import { DownOutlined } from '@ant-design/icons';

export default @connect(reduce, actions)
class PositionTools extends Component {
  constructor() {
    super();

    this.moveToFront = (e) => {
      e.stopPropagation();
      moveToFront(this.props.$element);
    };

    this.moveForward = (e) => {
      e.stopPropagation();
      moveForward(this.props.$element);
    };

    this.moveToBack = (e) => {
      e.stopPropagation();
      moveToBack(this.props.$element);
    };

    this.moveBackward = (e) => {
      e.stopPropagation();
      moveBackward(this.props.$element);
    };

    this.moveGroupForward = (e) => {
      e.stopPropagation();
      moveGroupForward(this.props.$element);
    };

    this.moveGroupBack = (e) => {
      e.stopPropagation();
      moveGroupBack(this.props.$element);
    };

    this.multiAlignCenterHorizontal = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'center-horizontal');
      this.props.updateElementAttribute('selectedMultiAligned', 'center-horizontal');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.multiAlignCenterVertical = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'center-vertical');
      this.props.updateElementAttribute('selectedMultiAligned', 'center-vertical');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.multiAlignTop = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'top');
      this.props.updateElementAttribute('selectedMultiAligned', 'top');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.multiAlignRight = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'right');
      this.props.updateElementAttribute('selectedMultiAligned', 'right');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.multiAlignBottom = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'bottom');
      this.props.updateElementAttribute('selectedMultiAligned', 'bottom');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.multiAlignLeft = (e) => {
      e.stopPropagation();
      multiAlign(this.props.$elements, 'left');
      this.props.updateElementAttribute('selectedMultiAligned', 'left');
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.distributeHorizontally = (e) => {
      e.stopPropagation();
      Renderer.distribute(true, false);
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.distributeVertically = (e) => {
      e.stopPropagation();
      Renderer.distribute(false, true);
      setTimeout(() => {
        Interactable.updateMultiinteractable();
      }, 100);
    };

    this.displayLayoutWidget = () => {
      if (util.isGroup(this.props.$element)) return false;
      return true;
    }
  };

  render(props, state) {
    const displayLayoutWidget = this.displayLayoutWidget();
    return (
      <div className="dropdown">
        {!props.isMobileVersion && <a className="dropdown-toggle icn rwd-icon" data-hint="Position">Position</a>}
        {props.isMobileVersion && <a className="dropdown-toggle mobile-tool-widget">
          <Position />
          <span>Position</span>
        </a>}
        <div className="dropdown-menu positions">
          {props.isMobileVersion && <div className="mobile-dropdown-header">
            <span>Position</span>
            <div className="dropdown-toggle"><DownOutlined /></div>
          </div>}
          {displayLayoutWidget &&
            <span><div className={'position-header'}>Layer</div>
              <ul>
                <li><a onClick={(e) => this.moveForward(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-bring-forward"} /></svg>Bring Forward</a></li>
                <li class="right-column"><a onClick={(e) => this.moveBackward(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-send-backward"} /></svg>Send Backward</a></li>
                <li><a onClick={(e) => this.moveToFront(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-bring-front"} /></svg>Bring to Front</a></li>
                <li class="right-column"><a onClick={(e) => this.moveToBack(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-send-back"} /></svg>Send to Back</a></li>

                <li className={!props.isInGroup ? 'hidden' : ''}>
                  <a onClick={(e) => this.moveGroupForward(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-forward"} /></svg>Group Forward</a>
                </li>
                <li className={!props.isInGroup ? 'hidden align-end' : 'align-end'}>
                  <a onClick={(e) => this.moveGroupBack(e)}><svg className="icn"><use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-back-arrow"} /></svg>Group Back</a>
                </li>
              </ul>
            </span>}
          <div>
            <div className={'position-header' + (displayLayoutWidget ? ' margin-top' : '')}>{props.isMultiSelect ? 'Align Elements' : 'Align to Page'}</div>
            <ul>
              <li>
                <a className={props.selectedMultiAligned === 'left' ? 'selected' : ''}
                  onClick={(e) => this.multiAlignLeft(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-left"} />
                  </svg>
                  <span className="align-label">Left</span>
                </a>
              </li>
              <li class="right-column">
                <a className={props.selectedMultiAligned === 'top' ? 'selected' : ''} onClick={(e) => this.multiAlignTop(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-top"} />
                  </svg>
                  <span className="align-label">Top</span>
                </a>
              </li>
              <li>
                <a className={props.selectedMultiAligned === 'center-vertical' ? 'selected' : ''} onClick={(e) => this.multiAlignCenterVertical(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-vertical"} />
                  </svg>
                  <span className="align-label">Center</span>
                </a>
              </li>
              <li class="right-column">
                <a className={props.selectedMultiAligned === 'center-horizontal' ? 'selected' : ''} onClick={(e) => this.multiAlignCenterHorizontal(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-center-horizontal"} />
                  </svg>
                  <span className="align-label">Middle</span>
                </a>
              </li>
              <li>
                <a className={props.selectedMultiAligned === 'right' ? 'selected' : ''} onClick={(e) => this.multiAlignRight(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-right"} />
                  </svg>
                  <span className="align-label">Right</span>
                </a>
              </li>
              <li class="right-column">
                <a className={props.selectedMultiAligned === 'bottom' ? 'selected' : ''} onClick={(e) => this.multiAlignBottom(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-multi-align-bottom"} />
                  </svg>
                  <span className="align-label">Bottom</span>
                </a>
              </li>
            </ul>

            <div className={'position-header' + (util.isGroup(props.$element) ? '' : ' margin-top') + (props.isMultiSelect ? '' : ' hidden')}>Distribute Elements</div>
            <ul className={props.isMultiSelect ? '' : 'hidden'}>
              <li>
                <a onClick={(e) => this.distributeHorizontally(e)}>
                  <svg className="icn">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-enter-horizontal"} />
                  </svg>
                  <span className="align-label">Horizontally</span>
                </a>
              </li>

              <li>
                <a onClick={(e) => this.distributeVertically(e)}>
                  <svg className="icn rotate-90" style="margin: 0; position: relative; top: -.5px;">
                    <use xlinkHref={constants.appPrefix + "/svg/icons.svg#app-icon-enter-horizontal"} />
                  </svg>
                  <span className="align-label">Vertically</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    );
  };
}
